import RESUME_TITLE_1 from '@/material/ResumeTitle/ResumeTitle1/index.vue';
import RESUME_TITLE_2 from '@/material/ResumeTitle/ResumeTitle2/index.vue';

import CUSTOM_1 from '@/material/Custom/Custom1/NameAbstract.vue';
import CUSTOM_2 from '@/material/Custom/Custom2/ResumeTitleWord.vue';
import CUSTOM_3 from '@/material/Custom/Custom3/NameAbstractAvatar.vue';

import EDU_BACKGROUND_1 from '@/material/EduBackground/EduBackground1/index.vue';
import EDU_BACKGROUND_2 from '@/material/EduBackground/EduBackground2/EduBackground.vue';
import EDU_BACKGROUND_3 from '@/material/EduBackground/EduBackground3/EduBackground.vue';
import EDU_BACKGROUND_4 from '@/material/EduBackground/EduBackground4/EduBackground.vue';
import EDU_BACKGROUND_5 from '@/material/EduBackground/EduBackground5/EduBackground.vue';
import EDU_BACKGROUND_6 from '@/material/EduBackground/EduBackground6/EduBackground.vue';
import EDU_BACKGROUND_7 from '@/material/EduBackground/EduBackground7/EduBackground.vue';
import EDU_BACKGROUND_8 from '@/material/EduBackground/EduBackground8/EduBackground.vue';
import EDU_BACKGROUND_9 from '@/material/EduBackground/EduBackground9/EduBackground.vue';
import EDU_BACKGROUND_10 from '@/material/EduBackground/EduBackground10/EduBackground.vue';
import EDU_BACKGROUND_11 from '@/material/EduBackground/EduBackground11/EduBackground.vue';
import EDU_BACKGROUND_12 from '@/material/EduBackground/EduBackground12/EduBackground.vue';

import BASE_INFO_1 from '@/material/BaseInfo/BaseInfo1/index.vue';
import BASE_INFO_2 from '@/material/BaseInfo/BaseInfo2/BaseInfo.vue';
import BASE_INFO_3 from '@/material/BaseInfo/BaseInfo3/BaseInfo.vue';
import BASE_INFO_4 from '@/material/BaseInfo/BaseInfo4/BaseInfo.vue';
import BASE_INFO_5 from '@/material/BaseInfo/BaseInfo5/BaseInfo.vue';
import BASE_INFO_6 from '@/material/BaseInfo/BaseInfo6/BaseInfo.vue';
import BASE_INFO_7 from '@/material/BaseInfo/BaseInfo7/BaseInfo.vue';
import BASE_INFO_8 from '@/material/BaseInfo/BaseInfo8/BaseInfo.vue';
import BASE_INFO_9 from '@/material/BaseInfo/BaseInfo9/BaseInfo.vue';

import JOB_INTENTION_1 from '@/material/JobIntention/JobIntention1/index.vue';
import JOB_INTENTION_2 from '@/material/JobIntention/JobIntention2/JobIntention.vue';
import JOB_INTENTION_3 from '@/material/JobIntention/JobIntention3/JobIntention.vue';
import JOB_INTENTION_4 from '@/material/JobIntention/JobIntention4/JobIntention.vue';
import JOB_INTENTION_5 from '@/material/JobIntention/JobIntention5/JobIntention.vue';
import JOB_INTENTION_6 from '@/material/JobIntention/JobIntention6/JobIntention.vue';
import JOB_INTENTION_7 from '@/material/JobIntention/JobIntention7/JobIntention.vue';
import JOB_INTENTION_8 from '@/material/JobIntention/JobIntention8/JobIntention.vue';
import JOB_INTENTION_9 from '@/material/JobIntention/JobIntention9/JobIntention.vue';
import JOB_INTENTION_10 from '@/material/JobIntention/JobIntention10/JobIntention.vue';

import SKILL_SPECIALTIES_1 from '@/material/SkillSpecialties/SkillSpecialties1/index.vue';
import SKILL_SPECIALTIES_2 from '@/material/SkillSpecialties/SkillSpecialties2/SkillSpecialties.vue';
import SKILL_SPECIALTIES_3 from '@/material/SkillSpecialties/SkillSpecialties3/SkillSpecialties.vue';
import SKILL_SPECIALTIES_4 from '@/material/SkillSpecialties/SkillSpecialties4/SkillSpecialties.vue';
import SKILL_SPECIALTIES_5 from '@/material/SkillSpecialties/SkillSpecialties5/SkillSpecialties.vue';
import SKILL_SPECIALTIES_6 from '@/material/SkillSpecialties/SkillSpecialties6/SkillSpecialties.vue';
import SKILL_SPECIALTIES_7 from '@/material/SkillSpecialties/SkillSpecialties7/SkillSpecialties.vue';
import SKILL_SPECIALTIES_8 from '@/material/SkillSpecialties/SkillSpecialties8/SkillSpecialties.vue';
import SKILL_SPECIALTIES_9 from '@/material/SkillSpecialties/SkillSpecialties9/SkillSpecialties.vue';
import SKILL_SPECIALTIES_10 from '@/material/SkillSpecialties/SkillSpecialties10/SkillSpecialties.vue';
import SKILL_SPECIALTIES_11 from '@/material/SkillSpecialties/SkillSpecialties11/SkillSpecialties.vue';
import SKILL_SPECIALTIES_12 from '@/material/SkillSpecialties/SkillSpecialties12/SkillSpecialties.vue';
import SKILL_SPECIALTIES_13 from '@/material/SkillSpecialties/SkillSpecialties13/SkillSpecialties.vue';
import SKILL_SPECIALTIES_14 from '@/material/SkillSpecialties/SkillSpecialties14/SkillSpecialties.vue';
import SKILL_SPECIALTIES_15 from '@/material/SkillSpecialties/SkillSpecialties15/SkillSpecialties.vue';
import SKILL_SPECIALTIES_16 from '@/material/SkillSpecialties/SkillSpecialties16/SkillSpecialties.vue';
import SKILL_SPECIALTIES_17 from '@/material/SkillSpecialties/SkillSpecialties17/SkillSpecialties.vue';

import CAMPUS_EXPERIENCE_1 from '@/material/CampusExperience/CampusExperience1/index.vue';
import CAMPUS_EXPERIENCE_2 from '@/material/CampusExperience/CampusExperience2/CampusExperience.vue';
import CAMPUS_EXPERIENCE_3 from '@/material/CampusExperience/CampusExperience3/CampusExperience.vue';
import CAMPUS_EXPERIENCE_4 from '@/material/CampusExperience/CampusExperience4/CampusExperience.vue';
import CAMPUS_EXPERIENCE_5 from '@/material/CampusExperience/CampusExperience5/CampusExperience.vue';
import CAMPUS_EXPERIENCE_6 from '@/material/CampusExperience/CampusExperience6/CampusExperience.vue';
import CAMPUS_EXPERIENCE_7 from '@/material/CampusExperience/CampusExperience7/CampusExperience.vue';
import CAMPUS_EXPERIENCE_8 from '@/material/CampusExperience/CampusExperience8/CampusExperience.vue';
import CAMPUS_EXPERIENCE_9 from '@/material/CampusExperience/CampusExperience9/CampusExperience.vue';
import CAMPUS_EXPERIENCE_10 from '@/material/CampusExperience/CampusExperience10/CampusExperience.vue';

import INTERNSHIP_EXPERIENCE_1 from '@/material/InternshipExperience/InternshipExperience1/index.vue';
import INTERNSHIP_EXPERIENCE_2 from '@/material/InternshipExperience/InternshipExperience2/InternshipExperience.vue';
import INTERNSHIP_EXPERIENCE_3 from '@/material/InternshipExperience/InternshipExperience3/InternshipExperience.vue';
import INTERNSHIP_EXPERIENCE_4 from '@/material/InternshipExperience/InternshipExperience4/InternshipExperience.vue';
import INTERNSHIP_EXPERIENCE_5 from '@/material/InternshipExperience/InternshipExperience5/InternshipExperience.vue';
import INTERNSHIP_EXPERIENCE_6 from '@/material/InternshipExperience/InternshipExperience6/InternshipExperience.vue';
import INTERNSHIP_EXPERIENCE_7 from '@/material/InternshipExperience/InternshipExperience7/InternshipExperience.vue';
import INTERNSHIP_EXPERIENCE_8 from '@/material/InternshipExperience/InternshipExperience8/InternshipExperience.vue';
import INTERNSHIP_EXPERIENCE_9 from '@/material/InternshipExperience/InternshipExperience9/InternshipExperience.vue';
import INTERNSHIP_EXPERIENCE_10 from '@/material/InternshipExperience/InternshipExperience10/InternshipExperience.vue';

import WORK_EXPERIENCE_1 from '@/material/WorkExperience/WorkExperience1/index.vue';
import WORK_EXPERIENCE_2 from '@/material/WorkExperience/WorkExperience2/WorkExperience.vue';
import WORK_EXPERIENCE_3 from '@/material/WorkExperience/WorkExperience3/WorkExperienceCom.vue';
import WORK_EXPERIENCE_4 from '@/material/WorkExperience/WorkExperience4/WorkExperience.vue';
import WORK_EXPERIENCE_5 from '@/material/WorkExperience/WorkExperience5/WorkExperience.vue';
import WORK_EXPERIENCE_6 from '@/material/WorkExperience/WorkExperience6/WorkExperience.vue';
import WORK_EXPERIENCE_7 from '@/material/WorkExperience/WorkExperience7/WorkExperience.vue';
import WORK_EXPERIENCE_8 from '@/material/WorkExperience/WorkExperience8/WorkExperience.vue';
import WORK_EXPERIENCE_9 from '@/material/WorkExperience/WorkExperience9/WorkExperience.vue';
import WORK_EXPERIENCE_10 from '@/material/WorkExperience/WorkExperience10/WorkExperience.vue';

import PROJECT_EXPERIENCE_1 from '@/material/ProjectExperience/ProjectExperience1/index.vue';
import PROJECT_EXPERIENCE_2 from '@/material/ProjectExperience/ProjectExperience2/ProjectExperience.vue';
import PROJECT_EXPERIENCE_3 from '@/material/ProjectExperience/ProjectExperience3/ProjectExperience.vue';
import PROJECT_EXPERIENCE_4 from '@/material/ProjectExperience/ProjectExperience4/ProjectExperience.vue';
import PROJECT_EXPERIENCE_5 from '@/material/ProjectExperience/ProjectExperience5/ProjectExperience.vue';
import PROJECT_EXPERIENCE_6 from '@/material/ProjectExperience/ProjectExperience6/ProjectExperience.vue';
import PROJECT_EXPERIENCE_7 from '@/material/ProjectExperience/ProjectExperience7/ProjectExperience.vue';
import PROJECT_EXPERIENCE_8 from '@/material/ProjectExperience/ProjectExperience8/ProjectExperience.vue';
import PROJECT_EXPERIENCE_9 from '@/material/ProjectExperience/ProjectExperience9/ProjectExperience.vue';
import PROJECT_EXPERIENCE_10 from '@/material/ProjectExperience/ProjectExperience10/ProjectExperience.vue';

import AWARDS_1 from '@/material/Awards/Awards1/index.vue';
import AWARDS_2 from '@/material/Awards/Awards2/Awards.vue';
import AWARDS_3 from '@/material/Awards/Awards3/Awards.vue';
import AWARDS_4 from '@/material/Awards/Awards4/Awards.vue';
import AWARDS_5 from '@/material/Awards/Awards5/Awards.vue';
import AWARDS_6 from '@/material/Awards/Awards6/Awards.vue';
import AWARDS_7 from '@/material/Awards/Awards7/Awards.vue';
import AWARDS_8 from '@/material/Awards/Awards8/Awards.vue';
import AWARDS_9 from '@/material/Awards/Awards9/Awards.vue';
import AWARDS_10 from '@/material/Awards/Awards10/Awards.vue';

import HOBBIES_1 from '@/material/Hobbies/Hobbies1/index.vue';
import HOBBIES_2 from '@/material/Hobbies/Hobbies2/Hobbies.vue';
import HOBBIES_3 from '@/material/Hobbies/Hobbies3/Hobbies.vue';
import HOBBIES_4 from '@/material/Hobbies/Hobbies4/Hobbies.vue';
import HOBBIES_5 from '@/material/Hobbies/Hobbies5/Hobbies.vue';
import HOBBIES_6 from '@/material/Hobbies/Hobbies6/Hobbies.vue';
import HOBBIES_7 from '@/material/Hobbies/Hobbies7/Hobbies.vue';
import HOBBIES_8 from '@/material/Hobbies/Hobbies8/Hobbies.vue';
import HOBBIES_9 from '@/material/Hobbies/Hobbies9/Hobbies.vue';
import HOBBIES_10 from '@/material/Hobbies/Hobbies10/Hobbies.vue';

import SELF_EVALUATION_1 from '@/material/SelfEvaluation/SelfEvaluation1/index.vue';
import SELF_EVALUATION_2 from '@/material/SelfEvaluation/SelfEvaluation2/SelfEvaluation.vue';
import SELF_EVALUATION_3 from '@/material/SelfEvaluation/SelfEvaluation3/SelfEvaluation.vue';
import SELF_EVALUATION_4 from '@/material/SelfEvaluation/SelfEvaluation4/SelfEvaluation.vue';
import SELF_EVALUATION_5 from '@/material/SelfEvaluation/SelfEvaluation5/SelfEvaluation.vue';
import SELF_EVALUATION_6 from '@/material/SelfEvaluation/SelfEvaluation6/SelfEvaluation.vue';
import SELF_EVALUATION_7 from '@/material/SelfEvaluation/SelfEvaluation7/SelfEvaluation.vue';
import SELF_EVALUATION_8 from '@/material/SelfEvaluation/SelfEvaluation8/SelfEvaluation.vue';
import SELF_EVALUATION_9 from '@/material/SelfEvaluation/SelfEvaluation9/SelfEvaluation.vue';
import SELF_EVALUATION_10 from '@/material/SelfEvaluation/SelfEvaluation10/SelfEvaluation.vue';

import WORKS_DISPLAY_1 from '@/material/WorksDisplay/WorksDisplay1/index.vue';
import WORKS_DISPLAY_2 from '@/material/WorksDisplay/WorksDisplay2/WorksDisplay.vue';
import WORKS_DISPLAY_3 from '@/material/WorksDisplay/WorksDisplay3/WorksDisplay.vue';
import WORKS_DISPLAY_4 from '@/material/WorksDisplay/WorksDisplay4/WorksDisplay.vue';
import WORKS_DISPLAY_5 from '@/material/WorksDisplay/WorksDisplay5/WorksDisplay.vue';
import WORKS_DISPLAY_6 from '@/material/WorksDisplay/WorksDisplay6/WorksDisplay.vue';
import WORKS_DISPLAY_7 from '@/material/WorksDisplay/WorksDisplay7/WorksDisplay.vue';
import WORKS_DISPLAY_8 from '@/material/WorksDisplay/WorksDisplay8/WorksDisplay.vue';
import WORKS_DISPLAY_9 from '@/material/WorksDisplay/WorksDisplay9/WorksDisplay.vue';
import WORKS_DISPLAY_10 from '@/material/WorksDisplay/WorksDisplay10/WorksDisplay.vue';

// 注册所有物料组件
const MaterialComponents = {
  CUSTOM_1: CUSTOM_1,
  CUSTOM_2: CUSTOM_2,
  CUSTOM_3: CUSTOM_3,

  EDU_BACKGROUND_1: EDU_BACKGROUND_1,
  EDU_BACKGROUND_2: EDU_BACKGROUND_2,
  EDU_BACKGROUND_3: EDU_BACKGROUND_3,
  EDU_BACKGROUND_4: EDU_BACKGROUND_4,
  EDU_BACKGROUND_5: EDU_BACKGROUND_5,
  EDU_BACKGROUND_6: EDU_BACKGROUND_6,
  EDU_BACKGROUND_7: EDU_BACKGROUND_7,
  EDU_BACKGROUND_8: EDU_BACKGROUND_8,
  EDU_BACKGROUND_9: EDU_BACKGROUND_9,
  EDU_BACKGROUND_10: EDU_BACKGROUND_10,
  EDU_BACKGROUND_11: EDU_BACKGROUND_11,
  EDU_BACKGROUND_12: EDU_BACKGROUND_12,

  BASE_INFO_1: BASE_INFO_1,
  BASE_INFO_2: BASE_INFO_2,
  BASE_INFO_3: BASE_INFO_3,
  BASE_INFO_4: BASE_INFO_4,
  BASE_INFO_5: BASE_INFO_5,
  BASE_INFO_6: BASE_INFO_6,
  BASE_INFO_7: BASE_INFO_7,
  BASE_INFO_8: BASE_INFO_8,
  BASE_INFO_9: BASE_INFO_9,

  RESUME_TITLE_1: RESUME_TITLE_1,
  RESUME_TITLE_2: RESUME_TITLE_2,

  JOB_INTENTION_1: JOB_INTENTION_1,
  JOB_INTENTION_2: JOB_INTENTION_2,
  JOB_INTENTION_3: JOB_INTENTION_3,
  JOB_INTENTION_4: JOB_INTENTION_4,
  JOB_INTENTION_5: JOB_INTENTION_5,
  JOB_INTENTION_6: JOB_INTENTION_6,
  JOB_INTENTION_7: JOB_INTENTION_7,
  JOB_INTENTION_8: JOB_INTENTION_8,
  JOB_INTENTION_9: JOB_INTENTION_9,
  JOB_INTENTION_10: JOB_INTENTION_10,

  SKILL_SPECIALTIES_1: SKILL_SPECIALTIES_1,
  SKILL_SPECIALTIES_2: SKILL_SPECIALTIES_2,
  SKILL_SPECIALTIES_3: SKILL_SPECIALTIES_3,
  SKILL_SPECIALTIES_4: SKILL_SPECIALTIES_4,
  SKILL_SPECIALTIES_5: SKILL_SPECIALTIES_5,
  SKILL_SPECIALTIES_6: SKILL_SPECIALTIES_6,
  SKILL_SPECIALTIES_7: SKILL_SPECIALTIES_7,
  SKILL_SPECIALTIES_8: SKILL_SPECIALTIES_8,
  SKILL_SPECIALTIES_9: SKILL_SPECIALTIES_9,
  SKILL_SPECIALTIES_10: SKILL_SPECIALTIES_10,
  SKILL_SPECIALTIES_11: SKILL_SPECIALTIES_11,
  SKILL_SPECIALTIES_12: SKILL_SPECIALTIES_12,
  SKILL_SPECIALTIES_13: SKILL_SPECIALTIES_13,
  SKILL_SPECIALTIES_14: SKILL_SPECIALTIES_14,
  SKILL_SPECIALTIES_15: SKILL_SPECIALTIES_15,
  SKILL_SPECIALTIES_16: SKILL_SPECIALTIES_16,
  SKILL_SPECIALTIES_17: SKILL_SPECIALTIES_17,

  CAMPUS_EXPERIENCE_1: CAMPUS_EXPERIENCE_1,
  CAMPUS_EXPERIENCE_2: CAMPUS_EXPERIENCE_2,
  CAMPUS_EXPERIENCE_3: CAMPUS_EXPERIENCE_3,
  CAMPUS_EXPERIENCE_4: CAMPUS_EXPERIENCE_4,
  CAMPUS_EXPERIENCE_5: CAMPUS_EXPERIENCE_5,
  CAMPUS_EXPERIENCE_6: CAMPUS_EXPERIENCE_6,
  CAMPUS_EXPERIENCE_7: CAMPUS_EXPERIENCE_7,
  CAMPUS_EXPERIENCE_8: CAMPUS_EXPERIENCE_8,
  CAMPUS_EXPERIENCE_9: CAMPUS_EXPERIENCE_9,
  CAMPUS_EXPERIENCE_10: CAMPUS_EXPERIENCE_10,

  INTERNSHIP_EXPERIENCE_1: INTERNSHIP_EXPERIENCE_1,
  INTERNSHIP_EXPERIENCE_2: INTERNSHIP_EXPERIENCE_2,
  INTERNSHIP_EXPERIENCE_3: INTERNSHIP_EXPERIENCE_3,
  INTERNSHIP_EXPERIENCE_4: INTERNSHIP_EXPERIENCE_4,
  INTERNSHIP_EXPERIENCE_5: INTERNSHIP_EXPERIENCE_5,
  INTERNSHIP_EXPERIENCE_6: INTERNSHIP_EXPERIENCE_6,
  INTERNSHIP_EXPERIENCE_7: INTERNSHIP_EXPERIENCE_7,
  INTERNSHIP_EXPERIENCE_8: INTERNSHIP_EXPERIENCE_8,
  INTERNSHIP_EXPERIENCE_9: INTERNSHIP_EXPERIENCE_9,
  INTERNSHIP_EXPERIENCE_10: INTERNSHIP_EXPERIENCE_10,

  WORK_EXPERIENCE_1: WORK_EXPERIENCE_1,
  WORK_EXPERIENCE_2: WORK_EXPERIENCE_2,
  WORK_EXPERIENCE_3: WORK_EXPERIENCE_3,
  WORK_EXPERIENCE_4: WORK_EXPERIENCE_4,
  WORK_EXPERIENCE_5: WORK_EXPERIENCE_5,
  WORK_EXPERIENCE_6: WORK_EXPERIENCE_6,
  WORK_EXPERIENCE_7: WORK_EXPERIENCE_7,
  WORK_EXPERIENCE_8: WORK_EXPERIENCE_8,
  WORK_EXPERIENCE_9: WORK_EXPERIENCE_9,
  WORK_EXPERIENCE_10: WORK_EXPERIENCE_10,

  PROJECT_EXPERIENCE_1: PROJECT_EXPERIENCE_1,
  PROJECT_EXPERIENCE_2: PROJECT_EXPERIENCE_2,
  PROJECT_EXPERIENCE_3: PROJECT_EXPERIENCE_3,
  PROJECT_EXPERIENCE_4: PROJECT_EXPERIENCE_4,
  PROJECT_EXPERIENCE_5: PROJECT_EXPERIENCE_5,
  PROJECT_EXPERIENCE_6: PROJECT_EXPERIENCE_6,
  PROJECT_EXPERIENCE_7: PROJECT_EXPERIENCE_7,
  PROJECT_EXPERIENCE_8: PROJECT_EXPERIENCE_8,
  PROJECT_EXPERIENCE_9: PROJECT_EXPERIENCE_9,
  PROJECT_EXPERIENCE_10: PROJECT_EXPERIENCE_10,

  AWARDS_1: AWARDS_1,
  AWARDS_2: AWARDS_2,
  AWARDS_3: AWARDS_3,
  AWARDS_4: AWARDS_4,
  AWARDS_5: AWARDS_5,
  AWARDS_6: AWARDS_6,
  AWARDS_7: AWARDS_7,
  AWARDS_8: AWARDS_8,
  AWARDS_9: AWARDS_9,
  AWARDS_10: AWARDS_10,

  HOBBIES_1: HOBBIES_1,
  HOBBIES_2: HOBBIES_2,
  HOBBIES_3: HOBBIES_3,
  HOBBIES_4: HOBBIES_4,
  HOBBIES_5: HOBBIES_5,
  HOBBIES_6: HOBBIES_6,
  HOBBIES_7: HOBBIES_7,
  HOBBIES_8: HOBBIES_8,
  HOBBIES_9: HOBBIES_9,
  HOBBIES_10: HOBBIES_10,

  SELF_EVALUATION_1: SELF_EVALUATION_1,
  SELF_EVALUATION_2: SELF_EVALUATION_2,
  SELF_EVALUATION_3: SELF_EVALUATION_3,
  SELF_EVALUATION_4: SELF_EVALUATION_4,
  SELF_EVALUATION_5: SELF_EVALUATION_5,
  SELF_EVALUATION_6: SELF_EVALUATION_6,
  SELF_EVALUATION_7: SELF_EVALUATION_7,
  SELF_EVALUATION_8: SELF_EVALUATION_8,
  SELF_EVALUATION_9: SELF_EVALUATION_9,
  SELF_EVALUATION_10: SELF_EVALUATION_10,

  WORKS_DISPLAY_1: WORKS_DISPLAY_1,
  WORKS_DISPLAY_2: WORKS_DISPLAY_2,
  WORKS_DISPLAY_3: WORKS_DISPLAY_3,
  WORKS_DISPLAY_4: WORKS_DISPLAY_4,
  WORKS_DISPLAY_5: WORKS_DISPLAY_5,
  WORKS_DISPLAY_6: WORKS_DISPLAY_6,
  WORKS_DISPLAY_7: WORKS_DISPLAY_7,
  WORKS_DISPLAY_8: WORKS_DISPLAY_8,
  WORKS_DISPLAY_9: WORKS_DISPLAY_9,
  WORKS_DISPLAY_10: WORKS_DISPLAY_10
};
export default MaterialComponents;
